import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { resolveRateLimit } from '@app/shared/http-service/rate-limit.resolver';
import { RateLimitService } from '@app/shared/http-service/rate-limit.service';
import { Constants } from '@app/shared/models/constants';
import { RouteConstants } from '@app/shared/models/route-constants';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class RateLimitInterceptor implements HttpInterceptor {

	constructor (
		private readonly rateLimitService: RateLimitService,
		private readonly router: Router
	) { }

	intercept (req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			catchError((err: HttpErrorResponse) => {
				if (err.status === HttpStatusCode.TooManyRequests) {
					const match = resolveRateLimit(req.url, req.method);
					if (match) {
						const until = this.parseRetryAfter(err);
						if (until) {
							this.rateLimitService.setLockedUntil(match.key, until);
						}
						if (match.redirect) {
							void this.router.navigate([RouteConstants.Error429], {
								queryParams: until ? { until: until.toISOString() } : {},
							});
						}
					}
				}
				return throwError(() => err);
			})
		);
	}

	private parseRetryAfter (err: HttpErrorResponse): Date | null {
		const headers = err.headers;
		const retryAfter = headers.get(Constants.RetryAfterHeaderKey);

		if (retryAfter) {
			const seconds = Number(retryAfter);
			if (!isNaN(seconds)) {
				return new Date(Date.now() + seconds * 1000);
			}
			const dt = new Date(retryAfter);
			if (!isNaN(dt.getTime())) {
				return dt;
			}
		}

		return null;
	}
}